// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zpxciicizzdyxqqnixra.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpweGNpaWNpenpkeXhxcW5peHJhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYxODc1NzYsImV4cCI6MjA1MTc2MzU3Nn0.ybvQoDNXrbnWWUx_1UCBoqVJRyhOKwyDkVTup0Rlt8c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);